import { Button } from '@/domains/core/tamagoshiTailwind/components/Button/Button';
import { Typography } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import { Attributes } from '@/domains/productDiscovery/ProductPage/common/components/Attributes/Attributes';
import { Description } from '@/domains/productDiscovery/ProductPage/common/components/Description/Description';
import { descriptionPanelTitle } from '@/domains/productDiscovery/ProductPage/common/components/SidePanelContainer/SidePanelContainer';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import { useSidePanel } from '@/domains/productDiscovery/ProductPage/hooks/useSidePanel';
import { knowMore } from '@/domains/productDiscovery/ProductPage/translations';

export const DescriptionPreview = () => {
  const { description, modelId, attributes } = useDetail();
  const { goToDescription } = useSidePanel();

  if (!description) return null;

  return (
    <div>
      <Typography as="h2" scale="title3" className="mb-s">
        {descriptionPanelTitle}
      </Typography>
      <div
        style={{
          maxHeight: '25vh',
          maskImage:
            'linear-gradient(to bottom, #070f22 80%, transparent 100%)',
          WebkitMaskImage:
            'linear-gradient(to bottom, #070f22 80%, transparent 100%)',
        }}
      >
        <Description
          description={description}
          isExpanded={false}
          modelId={modelId}
          hideTitle
        />
        {attributes && attributes.length > 0 && (
          <Attributes
            defaultExpanded
            attributes={attributes}
            behavior="unfold"
          />
        )}
      </div>
      <Button
        onClick={goToDescription}
        size="M"
        text={knowMore}
        variant="link"
      />
    </div>
  );
};
